<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Visualizar Rede de Proteção</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <b-form-group label="Categoria de rede de proteção">
                  <b-form-select class="mb-3" v-model="form.categoria" :options="categorias" disabled>
                    <option v-for="item in categorias" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-form-group label="Nome do equipamento público">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" v-model="form.unidade" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Órgão Vínculado">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" v-model="form.orgao_vinculado" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <h4><strong>Endereço da Rede de Proteção</strong></h4>
          <hr>

          <b-row>
            <b-col cols="6">
              <b-form-group label="CEP">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.cep" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="UF:">
                <b-form-select v-model="form.uf_id" :options="estados" class="mb-3" disabled>
                  <option selected :value="null"> Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Município:">
                <b-form-select v-model="form.municipio_id" :options="cidades" disabled>
                  <option selected :value="null"> Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Endereço">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.endereco" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Número">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.numero" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Complemento">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.complemento" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group label="Bairro">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.bairro" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Latitude">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.latitude" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Longitude">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.longitude" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <br>

          <h4><strong>Contato da Rede de Proteção</strong></h4>
          <hr>

          <b-row>
            <b-col cols="4">
              <b-form-group label="E-mail">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.email" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Telefone">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.telefone" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Horário de atendimento">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="" v-model="form.horario" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarCategoriasRedes')

    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
  },
  data () {
    return {
      form: {
        id: null,
        categoria: null,
        unidade: null,
        orgao_vinculado: null,
        cnpj: null,
        matricula: null,
        uf_id: null,
        municipio_id: null,
        telefone: null,
        dependencia_administrativa: null,
        cep: null,
        endereco: null,
        complemento: null,
        numero: null,
        bairro: null,
        latitude: null,
        longitude: null,
        email: null,
        telefon: null,
        horario: null,
        users: []
      },
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      }
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadRede(this.$route.params.id)
    }
  },
  watch: {
    'form.uf_id': function () {
      if (this.form.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.form.uf_id)
      } else {
        this.form.uf_id = null
      }
    }
  },
  computed: {
    categorias () {
      return this.$store.state.categoriaRede.listaCategoriasRedes
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    loadRede (id) {
      Vue.http.get('api/redes-protecao/' + id).then((response) => {
        this.form.id = response.body.data.id
        this.form.unidade = response.body.data.data.unidade
        this.form.orgao_vinculado = response.body.data.data.unidade_administrativa
        this.form.uf_id = response.body.data.data.estado_id
        this.form.municipio_id = response.body.data.data.cidade_id
        this.form.telefone = response.body.data.data.telefone
        this.form.cep = response.body.data.data.cep
        this.form.endereco = response.body.data.data.endereco
        this.form.complemento = response.body.data.data.complemento
        this.form.numero = response.body.data.data.numero
        this.form.bairro = response.body.data.data.bairro
        this.form.latitude = response.body.data.data.latitude
        this.form.longitude = response.body.data.data.longitude
        this.form.email = response.body.data.data.email
        this.form.telefone = response.body.data.data.telefone
        this.form.horario = response.body.data.data.horario_atendimento

        if (response.body.data.data.categorias) {
          if (typeof this.$route.params.cat !== 'undefined') {
            response.body.data.data.categorias.map(element => {
              if (element.id === +(this.$route.params.cat)) this.form.categoria = element.id
            })
          } else { this.form.categoria = response.body.data.data.categorias[0].id }
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/rede/RedeForm.vue